import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { loginSuccess } from "./slices/auth/login/reducer";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// ChunkLoadError автомат reload — хуудас шилжих үед хуучин chunk дуудагдахаас болж гардаг
window.addEventListener("unhandledrejection", (event) => {
  const isChunkError =
    event.reason?.name === "ChunkLoadError" ||
    event.reason?.message?.includes("Loading chunk");
  if (isChunkError) {
    const RELOAD_KEY = "chunk_reload_at";
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    const now = Date.now();
    // 10 секундэд нэгээс илүү удаа reload хийхгүй — давтагдах loop-оос сэргийлнэ
    if (now - last > 10_000) {
      sessionStorage.setItem(RELOAD_KEY, now);
      window.location.reload();
    }
  }
});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

// ✅ Rehydrate Redux from localStorage before rendering
const savedAuthUser = localStorage.getItem("authUser");
if (savedAuthUser) {
  try {
    const parsedUser = JSON.parse(savedAuthUser);
    if (parsedUser?.accessToken && parsedUser?.data) {
      store.dispatch(loginSuccess(parsedUser.data));
    }
  } catch (err) {
    console.error("Failed to parse saved auth user:", err);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </Provider>
  </GoogleReCaptchaProvider>
);

reportWebVitals();
